import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { GET} from 'helpers/basicRequest';
import { Cargando } from "componentes/templates/cargando";
import {
    BtnBuscar
  } from "componentes/templates/btn_crud";
import LanguageHelper from 'helpers/language_helper';





const MenuBarReports= () => {
  const len = sessionStorage.getItem('languageId');
  const [items, setItems] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [key, setKeywords] = useState("");
  const [url, setUrl] = useState(
      `indicators/menuReports?le=${len}&k=${key}`
  );


  const gestionarBuscar = (event) => {
      event.preventDefault();
      setUrl(
          `indicators/menuReports?le=${len}&k=${key}`
      );
  };

  const obtenerFiltro = (event) => {
      setKeywords(event.target.value);
  };

  const prepararListado = (result) => {
      var resultados = result;



      setCargando(false);
      resultados.map((number) =>
          number.items = JSON.parse(number.items)

      );


      setItems(resultados);
  };

  useEffect(() => {
      const fetcher = async () => {
          const list = await GET(url);
          list.error ? console.log("error useEffect ", list.error) : prepararListado(list);

          return () => {
              setCargando(true);
          };
      };
      fetcher();

  }, [url]);
  if (cargando) return <Cargando />;
  else
      return (
          <>

              <div className="column is-3" style={{ float: 'left' }}>
                  <div >
                      <form onSubmit={gestionarBuscar}>
                          <div className="field has-addons">
                              <div className="control has-icons-left has-icons-right">
                                  <input
                                      className="input"
                                      type="text"
                                      name="k"
                                      id="k"
                                      onChange={obtenerFiltro}
                                      placeholder={LanguageHelper.getLanguageString('IndicatorsMenu.placeholder')}
                                  />
                                  <span className="icon is-small is-left">
                                      <i className="fas fa-key"></i>
                                  </span>
                              </div>
                              <div className="control">
                                  <BtnBuscar />
                              </div>
                          </div>
                      </form>
                  </div>
                  <Sidebar items={items} len={len} />

              </div>

          </>
      );
};
export default MenuBarReports;